import React from 'react';
import { Link } from 'react-router-dom';

const TabNavigation = ({ tabs, activeTab, baseUrl = '' }) => {
    return (
        <div className="flex border-b border-gray-less mb-4">
            {tabs.map(tab => (
                <Link
                    key={tab.id}
                    to={`${baseUrl}${tab.path}`}
                    className={`px-4 py-3 text-center font-medium ${activeTab === tab.id
                            ? 'text-blue-mid border-b-2 border-blue-mid'
                            : 'text-gray-mid hover:bg-gray-weak'
                        }`}
                >
                    {tab.label}
                </Link>
            ))}
        </div>
    );
};

export default TabNavigation;
